export default __webpack_public_path__ + "static/strektykkelse-detaljniva-eksempel1-44d99200e33d21c617d7283d30db1853.png";